<div class="audio-wrapper" *ngIf="isSpeechSynthesis">
    <div class="audio-on-off" [class.on]="isAudioOn" (click)="toggleAudio()">
        <span class="audio-icon">
            <img src="/images/chatbot/audio-off.svg" alt="Audio Off" />
            <img src="/images/chatbot/audio-off-active.svg" alt="Audio Off" />
        </span>
        <span class="audio-icon">
            <img src="/images/chatbot/audio-on.svg" alt="Audio On" />
            <img src="/images/chatbot/audio-on-active.svg" alt="Audio On" />
        </span>
    </div>
    <div class="audio-setting" (click)="openAudioSetting()">
        <img src="/images/chatbot/audio-setting.svg" alt="Audio Setting" />
        <img src="/images/chatbot/audio-setting-active.svg" alt="Audio Setting" />
    </div>
</div>
